<script>
import { mapActions, mapState } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';

export default {
  name: 'FerryExtraAdd',
  mixins: [
    validatorMixin,
  ],
  props: {
    shown: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      validForm: true,
      extra: null,
    };
  },
  computed: {
    ...mapState({
      saveError: state => state.transportation.extras.saveError,
      saveLoading: state => state.transportation.extras.saveLoading,
    }),
  },
  methods: {
    ...mapActions({
      addExtraByRoute: 'transportation/addExtraByRoute',
    }),
    saveExtra() {
      if (this.validForm) {
        const body = {
          ...this.extra,
          dateFrom: this.extra.dateFrom ? this.$moment(this.extra.dateFrom, 'DD/MM/YY').format('YYYY-MM-DD') : null,
          dateTo: this.extra.dateTo ? this.$moment(this.extra.dateTo, 'DD/MM/YY').format('YYYY-MM-DD') : null,
        };
        this.addExtraByRoute(body)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
    resetExtra() {
      this.extra = {
        name: null,
        webName: null,
        externalRef: null,
        active: true,
      };
    },
  },
  watch: {
    shown() {
      if (this.shown) {
        this.$refs.addExtraForm.resetValidation();
        this.resetExtra();
      }
    },
  },
  created() {
    this.resetExtra();
  },
};
</script>

<template>
  <v-card>
    <v-form v-model="validForm" @submit.prevent="saveExtra" ref="addExtraForm">
      <v-card-title>
        <span class="headline">
          Add Extra
        </span>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          v-if="saveLoading"
          :active="saveLoading"
          :height="4"
          class="my-0"
          indeterminate
        />
        <v-alert
          v-if="!saveLoading"
          :value="!!saveError"
          class="my-0 py-2"
          transition="slide-y-transition"
          outline
        >
          The extra could not be saved - please reload the page and try again
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="extra.name"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="extra.webName"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name displayed on the website"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="extra.externalRef"
                :rules="[rules.required]"
                :disabled="saveLoading"
                hint="External ref is used to identify the extra against suppliers system"
                label="External reference"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                v-model="extra.active"
                :disabled="saveLoading"
                label="Active"
                class="mt-0"
                hide-details
              />
            </v-flex>
          </v-layout>

          <v-divider class="my-3"></v-divider>

          <v-layout row>
            <v-flex xs12>
              <h3>Optional</h3>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs6>
              <v-text-field
                v-model="extra.dateFrom"
                :disabled="saveLoading"
                hint="dd/mm/yy"
                mask="##/##/##"
                label="Date From"
                return-masked-value
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="extra.dateTo"
                :disabled="saveLoading"
                hint="dd/mm/yy"
                mask="##/##/##"
                label="Date To"
                return-masked-value
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs6>
              <v-text-field
                v-model="extra.timeFrom"
                :disabled="saveLoading"
                hint="hh:mm"
                mask="##:##"
                label="Time From"
                return-masked-value
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="extra.timeTo"
                :disabled="saveLoading"
                hint="hh:mm"
                mask="##:##"
                label="Time To"
                return-masked-value
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click="$emit('close')"
          color="red darken-1"
          flat
        >
          Close
        </v-btn>
        <v-btn
          :disabled="!validForm || saveLoading"
          color="blue darken-1"
          type="submit"
          flat
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationExtraAdd.vue